import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Li = styled("li")`
    width: 100%;

    a {
        color: ${({theme}) => theme.uxfabric.components.link.inherit.enabled.textColor};
        text-decoration: none;
        padding: 0.375rem 0.5rem 0.375rem 0;
        margin: 0.125rem 0;
        display: inline-block;
        font-size: 0.875rem;
        line-height: 1.5;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        :hover {
            text-decoration: underline;
        }
        text-transform: ${({theme}) => theme.uxfabric.global.body3.textTransform};
        font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
        font-weight: ${({theme}) => theme.uxfabric.global.body3.fontWeight};
        font-size: ${({theme}) => theme.uxfabric.global.body3.fontSize};
    }
`
